import { Footer } from '@/components/elements/new-footer/Footer'
import { Header } from '@/components/elements/header/Header'
import Head from 'next/head'
import { DSGrid, DSGridBlock } from '@/components/ds/Grid/Grid'
import { DSSpacer } from '@zoe/ds-web'
import { LegalPagePageHeader } from './LegalPageHeader'
import { LegalPageContent } from './LegalPageContent'
import { useRouter } from 'next/router'
import { AnchorRecord, ExpandableSectionGroupRecord, HiddenAnchorRecord, TableOfContentRecord } from '../../../types'

type LegalPageRecordTypes = ExpandableSectionGroupRecord | AnchorRecord | HiddenAnchorRecord | TableOfContentRecord

export type LegalPageRecord = {
  id?: string
  pageName: string
  pageSlug: string
  pageTitle: string
  effectiveFrom: string
  archived: boolean
  country: string
  pageContent: {
    value: any
    blocks: Array<LegalPageRecordTypes>
  }
}

export type LegalArchivesPageRecord = {
  id?: string
  pageName: string
  pageContent: {
    value: any
  }
}

type LegalPageProps = {
  page: LegalPageRecord
  hideArchives?: boolean
}

export const LegalPage = ({ page, hideArchives }: LegalPageProps) => {
  const router = useRouter()
  const currentPath = router.asPath
  return (
    <>
      <Head>
        <title>{page.pageName}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <link rel="canonical" href={`${process.env.SITE_URL}/${currentPath}`} />
      </Head>

      <Header />

      <main>
        <DSSpacer size={96} direction="vertical" />
        <DSGrid>
          <DSGridBlock
            breakConfig={{
              s: { colSpan: 2 },
              m: { colSpan: 6 },
              xl: { colSpan: 6, offset: 3 },
              l: { colSpan: 6, offset: 3 },
            }}
          >
            <LegalPagePageHeader page={page} hideArchives={hideArchives} />
            <LegalPageContent page={page} />
          </DSGridBlock>
        </DSGrid>
        <DSSpacer size={72} direction="vertical" />
      </main>

      <Footer />
    </>
  )
}
